import { render, staticRenderFns } from "./newExamModal.vue?vue&type=template&id=ef7c44d8&"
import script from "./newExamModal.vue?vue&type=script&lang=js&"
export * from "./newExamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports